'use client';

import { useState, useEffect } from 'react';
import Link from 'next/link';
import { useTranslations } from 'next-intl';
import styles from './ProductsV2.module.css';

export default function ProductsV2({ locale = 'en' }) {
  const t = useTranslations('home');
  const [products, setProducts] = useState([]);

  useEffect(() => {
    async function fetchProducts() {
      try {
        const res = await fetch('/api/bigbuy/products?perPage=500', { cache: 'no-store' });
        if (res.ok) {
          const data = await res.json();
          // Pick products that have images, prefer in-stock
          const withImages = (data.data || []).filter(p => p.image && !p.image.includes('placeholder'));
          const inStock = withImages.filter(p => p.inStock);
          const picks = inStock.length >= 4 ? inStock.slice(0, 4) : withImages.slice(0, 4);
          setProducts(picks);
        }
      } catch (err) {
        console.error('Failed to fetch products for homepage:', err);
      }
    }
    fetchProducts();
  }, []);

  if (products.length === 0) return null;

  return (
    <section className={styles.section}>
      <div className={styles.container}>
        <div className={styles.header}>
          <h2 className={styles.title}>{t('bestSellers')}</h2>
          <Link href={`/${locale}/productos`} className={styles.viewAll}>
            {t('viewAll') || 'View All'} →
          </Link>
        </div>

        <div className={styles.grid}>
          {products.map((product) => (
            <Link
              key={product.id}
              href={`/${locale}/productos/${product.id}`}
              className={styles.card}
            >
              <div className={styles.imageWrapper}>
                <img
                  src={product.image}
                  alt={product.names?.[locale] || product.name}
                  className={styles.image}
                  loading="lazy"
                />
                {product.discount > 0 && (
                  <span className={styles.badge}>-{product.discount}%</span>
                )}
              </div>

              <div className={styles.content}>
                <h3 className={styles.name}>
                  {product.names?.[locale] || product.name}
                </h3>

                <p className={styles.price}>€{(product.price || 0).toFixed(2)}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
